











































































































































































































































import {
  defineComponent,
  ref,
  computed,
  watch,
  ComputedRef,
  onMounted,
  PropType,
} from '@vue/composition-api';
import { AddTextInfo, TextRow, AppliedProperty } from '@oare/types';
import PropertiesTree from '@/components/Properties/PropertiesTree.vue';
import PropertiesDisplay from '@/components/Properties/PropertiesDisplay.vue';

export default defineComponent({
  props: {
    existingTextRow: {
      type: Object as PropType<TextRow>,
      required: false,
    },
  },
  components: {
    PropertiesTree,
    PropertiesDisplay,
  },
  setup(props, { emit }) {
    const textName = ref('');
    const cdliNum = ref('');
    const excavationPrefix = ref('');
    const excavationNumber = ref('');
    const museumPrefix = ref('');
    const museumNumber = ref('');
    const publicationPrefix = ref('');
    const publicationNumber = ref('');

    const selectPropertiesDialog = ref(false);
    const formComplete = ref(false);

    const properties = ref<AppliedProperty[]>([]);

    const setProperties = (propertyList: AppliedProperty[]) => {
      properties.value = propertyList;
    };

    const textInfo: ComputedRef<AddTextInfo> = computed(() => ({
      textName: textName.value && textName.value !== '' ? textName.value : null,
      cdliNum: cdliNum.value && cdliNum.value !== '' ? cdliNum.value : null,
      excavationPrefix:
        excavationPrefix.value && excavationPrefix.value !== ''
          ? excavationPrefix.value
          : null,
      excavationNumber:
        excavationNumber.value && excavationNumber.value !== ''
          ? excavationNumber.value
          : null,
      museumPrefix:
        museumPrefix.value && museumPrefix.value !== ''
          ? museumPrefix.value
          : null,
      museumNumber:
        museumNumber.value && museumNumber.value !== ''
          ? museumNumber.value
          : null,
      publicationPrefix:
        publicationPrefix.value && publicationPrefix.value !== ''
          ? publicationPrefix.value
          : null,
      publicationNumber:
        publicationNumber.value && publicationNumber.value !== ''
          ? publicationNumber.value
          : null,
      properties: properties.value,
    }));

    watch(textInfo, () => emit('update-text-info', textInfo.value), {
      deep: true,
    });

    const stepComplete = computed(() => {
      const hasTextName = textName.value !== '';

      const hasExcavationInfo =
        excavationPrefix.value !== '' && excavationNumber.value !== '';
      const hasMuseumInfo =
        museumPrefix.value !== '' && museumNumber.value !== '';
      const hasPublicationInfo =
        publicationPrefix.value !== '' && publicationNumber.value !== '';

      const hasCollectionInfo =
        hasExcavationInfo || hasMuseumInfo || hasPublicationInfo;

      return hasTextName && hasCollectionInfo;
    });

    watch(stepComplete, () => emit('step-complete', stepComplete.value));

    const textNameRules = [
      (input: string) => {
        if (input === '') {
          return 'Required';
        }
        return true;
      },
    ];

    onMounted(async () => {
      if (props.existingTextRow) {
        textName.value = props.existingTextRow.name || '';
        cdliNum.value = props.existingTextRow.cdliNum || '';
        excavationPrefix.value = props.existingTextRow.excavationPrefix || '';
        excavationNumber.value = props.existingTextRow.excavationNumber || '';
        museumPrefix.value = props.existingTextRow.museumPrefix || '';
        museumNumber.value = props.existingTextRow.museumNumber || '';
        publicationPrefix.value = props.existingTextRow.publicationPrefix || '';
        publicationNumber.value = props.existingTextRow.publicationNumber || '';
      }
    });

    return {
      textName,
      cdliNum,
      excavationPrefix,
      excavationNumber,
      museumPrefix,
      museumNumber,
      publicationPrefix,
      publicationNumber,
      selectPropertiesDialog,
      formComplete,
      properties,
      setProperties,
      textInfo,
      textNameRules,
    };
  },
});
